// tslint:disable max-line-length
import {
  ClockCircleOutlined,
  EyeOutlined,
  MailOutlined,
  QuestionCircleOutlined,
  SafetyOutlined,
  SendOutlined,
  SettingFilled,
  MinusOutlined,
  StopOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Button, Heading, Spinner, Tooltip } from '@mm/components';
import {
  AngleDownLightIcon,
  AngleUpLightIcon,
  QuestionCircleIcon,
} from '@mm/icons';
import { useAutomationActions } from '@mm/state/actions/automationActions';
import { useViewActions } from '@mm/state/actions/viewActions';
import PageModel from '@mm/state/model/PageModel';
import WidgetModel, {
  EmailConfig,
  WidgetTypes,
} from '@mm/state/model/WidgetModel';
import { IAutomationState } from '@mm/state/reducers/automation';
import {
  activeChatbotIdSelector,
  activeFacebookPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { ReactComponent as HeartbeatIcon } from 'assets/icons/heartbeat.svg';
import classNames from 'classnames';
import { first } from 'lodash';
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PrimaryToolTip } from '../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import { AutomationChannelButton } from '../components/AutomationChannelButton';
import { AutomationHeader } from '../components/AutomationHeader/AutomationHeader';
import { ActionsList } from './ActionsList/ActionsList';
import automationStyles from '../automationStyles.module.css';
import styles from './AutomationEdit.module.css';
import { DialogueEditor } from './DialogueEditor/DialogueEditor';
import { Count } from './DialogueEditor/NodeTypes/elements/Count/Count';
import { ReviewBadge } from './DialogueEditor/NodeTypes/elements/ReviewBadge/ReviewBadge';
import common from './DialogueEditor/NodeTypes/index.module.css';
import { useDialogues } from './DialogueEditor/use-fetch-dialogue';
import bgIcon from './icons/bg.svg';
import { InputTriggers } from './InputTriggers/InputTriggers';
import { NewInputTriggerChooser } from './InputTriggers/NewInputTriggerChooser';
import { useInputTriggersIdentification } from './InputTriggers/use-input-triggers-identification';
import { Step } from './Step/Step';
import { TransitionWrapper } from './TransitionWrapper/TransitionWrapper';
import { useAutomation } from './use-automation';
import { useInactiveBotActivator } from '../../../../../common/hooks/use-inactive-bot-activator';
import AutomationController, {
  AutomationVerifiedStatsType,
} from '@mm/state/controllers/AutomationController';
import moment from 'moment';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import PrimarySelect, {
  DropdownOption,
  PrimarySelectOuterProps,
} from '../../../../../../common/components/PrimarySelect/PrimarySelect';
import { hasParentWithSelector } from '@mm/utils';
import { CampaignType } from '@mm/state/model/CampaignsModel';
import { selectCampaignById } from '@mm/state/selectors/campaignSelectors';
import {
  errorToast,
  successToast,
} from '../../../../../../common/helpers/toast';
import { useCampaignCRUDActions } from '@mm/state/actions/CampaignsCRUDActions';
import { soldConfigInitialValues } from '../../../../../components/SlideoutMenu/menus/AutomationSoLDSettingsSlideout/AutomationSoLDSettingsSlideout';
import { CampaignDialogueEditor } from './CampaignDialogueEditor/CampaignDialogueEditor';
import { EAutomationAction } from '@mm/state/model/AutomationModel';
import { PeopleIcon } from '@mm/icons/general/PeopleIcon';
import { MailIcon } from '@mm/icons/general/MailIcon';
import { ClickIcon } from '@mm/icons/general/ClickIcon';
import { numFormatter } from '../../../../../../common/helpers/string-helpers';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { Scheduler } from './DialogueEditor/NodeTypes/Scheduler/Scheduler';
import { InactiveBotAlert } from '../../../../../components/InactiveBotAlert/InactiveBotAlert';
import { InactiveEmailAlert } from '../../../../../components/InactiveEmailAlert/InactiveEmailAlert';
import { selectEmailAccounts } from '@mm/state/selectors/emailAccountsSelectors';
import { useEmailAccountCRUDActions } from '@mm/state/actions/EmailAccountCRUDActions';

interface Props {
  automationData: ReturnType<typeof useAutomation>;
}

export const SoldIcon = ({ className }) => (
  <div className={classNames(className, automationStyles.soldIcon)}>
    <MailOutlined className={automationStyles.purple} />
    <HeartbeatIcon className={automationStyles.soldHeartIcon} />
  </div>
);

export const HandIcon = ({ className, color = '#8C8C8C' }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill={color}
        d="M15.84 7.566a.705.705 0 0 0-1.199-.5c-.15.145-2.714 2.701-2.938 2.924a.561.561 0 0 1-.792-.795l4.877-4.859a.7.7 0 0 0 .208-.498.699.699 0 0 0-.207-.498l-.019-.02a.705.705 0 0 0-.994 0l-4.381 4.362a.56.56 0 0 1-.792-.794c1.4-1.398 3.326-3.313 4.722-4.704a.7.7 0 0 0 .208-.498.7.7 0 0 0-.207-.498l-.023-.024a.7.7 0 0 0-.498-.206.699.699 0 0 0-.498.206l-4.71 4.71a.561.561 0 0 1-.794-.793l3.865-3.865a.7.7 0 0 0 .206-.497.699.699 0 0 0-.206-.498l-.015-.016a.704.704 0 0 0-.995 0l-6.29 6.291a.56.56 0 0 1-.942-.529l1.076-4.442a.873.873 0 1 0-1.702-.4l-.083.363C2.297 3.324 1.607 5.165.664 6.96a5.858 5.858 0 0 0-.605 3.536A5.76 5.76 0 0 0 1.7 13.769a5.77 5.77 0 0 0 4.108 1.701h.004a5.77 5.77 0 0 0 4.109-1.706l1.398-1.402 4.314-4.298a.699.699 0 0 0 .206-.498ZM14.477 12.192a.469.469 0 1 0-.862-.369 3.126 3.126 0 0 1-.667.984c-.348.348-.76.604-1.224.758a.469.469 0 1 0 .296.89 4.037 4.037 0 0 0 1.591-.985c.37-.37.662-.8.866-1.278ZM15.716 12.45a.469.469 0 0 0-.616.247c-.219.51-.531.971-.928 1.368a4.336 4.336 0 0 1-1.614 1.025.469.469 0 0 0 .316.882c.741-.265 1.4-.684 1.96-1.244.482-.482.862-1.04 1.128-1.662a.469.469 0 0 0-.246-.615Z"
      />
    </svg>
  </div>
);

export const HotLeadIcon = ({ className, color = '#389E0D' }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" fill="none">
      <path
        fill={color}
        d="m13.73 9.626-.55-.524a.94.94 0 0 0-.652-.256c-.247 0-.5.091-.672.256L8.29 12.47V1.77A.863.863 0 0 0 7.41.893h-.78c-.508 0-.972.393-.972.875v10.74L2.1 9.102a.909.909 0 0 0-.638-.256.924.924 0 0 0-.645.256l-.549.524a.846.846 0 0 0 .002 1.238l6.077 5.774a.943.943 0 0 0 .654.256h.002a.94.94 0 0 0 .652-.256l6.076-5.774a.845.845 0 0 0 0-1.238Z"
      />
    </svg>
  </div>
);

export const ReplyIcon = ({ color = '#262626' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" fill="none">
    <path
      fill={color}
      d="M5.732 11.82a.551.551 0 0 1-.414-.185L.89 6.653a.554.554 0 0 1 0-.735L5.318.936a.554.554 0 0 1 .827.736L2.044 6.285 6.146 10.9a.553.553 0 0 1-.414.922Z"
    />
    <path
      fill="#262626"
      d="M8.751 11.82a.554.554 0 0 1-.414-.185L3.91 6.653a.554.554 0 0 1 0-.735L8.337.936a.554.554 0 0 1 .968.368v2.252c1.63.186 6.29 1.276 7.19 7.633a.554.554 0 0 1-.948.46c-2.085-2.177-5.05-2.537-6.242-2.59v2.208a.554.554 0 0 1-.554.554ZM5.064 6.286l3.134 3.526V8.5a.553.553 0 0 1 .525-.552c2.254-.044 4.468.599 6.348 1.843-1.502-5.182-6.107-5.18-6.31-5.165a.6.6 0 0 1-.398-.159.554.554 0 0 1-.165-.395V2.76L5.064 6.285Z"
    />
  </svg>
);

export const ClickOptIcon = ({ color = '#262626' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none">
    <path
      fill={color}
      d="M8.7 16.65a.53.53 0 0 1-.508-.378l-3.18-10.6a.53.53 0 0 1 .66-.66l10.6 3.18a.53.53 0 0 1 .142.949l-2.642 1.761 2.723 2.723a.53.53 0 0 1 0 .75l-2.12 2.12a.53.53 0 0 1-.75 0l-2.723-2.723-1.76 2.641a.53.53 0 0 1-.442.237Zm2.12-4.24a.53.53 0 0 1 .374.155L14 15.37 15.37 14l-2.805-2.806a.53.53 0 0 1 .08-.815l2.244-1.495L6.31 6.31l2.573 8.578 1.495-2.242a.53.53 0 0 1 .44-.236ZM3.775 3.775a.53.53 0 0 0 0-.75l-1.06-1.06a.53.53 0 1 0-.75.75l1.06 1.06a.528.528 0 0 0 .75 0ZM3.4 5.52a.53.53 0 0 0-.53-.53H1.28a.53.53 0 0 0 0 1.06h1.59a.53.53 0 0 0 .53-.53Zm-.685 3.555 1.06-1.06a.53.53 0 1 0-.75-.75l-1.06 1.06a.53.53 0 1 0 .75.75Zm5.3-5.3 1.06-1.06a.53.53 0 1 0-.75-.75l-1.06 1.06a.53.53 0 1 0 .75.75ZM6.05 2.87V1.28a.53.53 0 0 0-1.06 0v1.59a.53.53 0 0 0 1.06 0Z"
    />
  </svg>
);

export enum EAutomationReportingEvents {
  EMAIL_OPEN = 'open',
  EMAIL_REPLY = 'reply',
  CLICK_LINK = 'click',
}

export const REPORTING_OPTIONS = [
  {
    id: EAutomationReportingEvents.EMAIL_OPEN,
    name: 'Opens an email',
    icon: <EyeOutlined />,
  },
  {
    id: EAutomationReportingEvents.CLICK_LINK,
    name: 'Clicks a link',
    icon: <ClickOptIcon />,
  },
  // hide until BE is implemented
  // {
  //   id: EAutomationReportingEvents.EMAIL_REPLY,
  //   name: 'Replies to an email',
  //   icon: <ReplyIcon />,
  // },
];

export const getIsCampaignReportingStatusActive = campaign => {
  if (campaign?.soldConfigurations.unicorn?.notifications?.rule) {
    return Object.values(
      campaign.soldConfigurations.unicorn.notifications.rule,
    ).some(value => Number(value) > 0);
  }
};

export const getIsRelatedCampaignReportingStatusActive = campaign =>
  Object.values(campaign?.soldConfigurations?.unicorn || {}).some(
    value => Number(value) > 0,
  );

export const getCampaignActiveReportingOptionId = campaign => {
  if (campaign?.soldConfigurations) {
    switch (true) {
      case !!campaign.soldConfigurations.unicorn.notifications.rule.click: {
        return EAutomationReportingEvents.CLICK_LINK;
      }
      case !!campaign.soldConfigurations.unicorn.notifications.rule.reply: {
        return EAutomationReportingEvents.EMAIL_REPLY;
      }
      case !!campaign.soldConfigurations.unicorn.notifications.rule.open: {
        return EAutomationReportingEvents.EMAIL_OPEN;
      }
      default:
        return EAutomationReportingEvents.EMAIL_OPEN;
    }
  }
};

export const getCampaignSoldReportingOptionId = campaign => {
  if (campaign?.soldConfigurations) {
    switch (true) {
      case !!campaign.soldConfigurations.unicorn.click: {
        return EAutomationReportingEvents.CLICK_LINK;
      }
      case !!campaign.soldConfigurations.unicorn.reply: {
        return EAutomationReportingEvents.EMAIL_REPLY;
      }
      case !!campaign.soldConfigurations.unicorn.open: {
        return EAutomationReportingEvents.EMAIL_OPEN;
      }
      default:
        return EAutomationReportingEvents.EMAIL_OPEN;
    }
  }
};

const AUTOMATION_REPORTING_EVENT_SELECTOR_JS_CLASS =
  '.automation-reporting-event-selector';

export const AutomationReportingEventSelector = ({
  ...props
}: Omit<PrimarySelectOuterProps, 'options' | 'value'> & {
  value?: string | number;
}) => {
  const value = REPORTING_OPTIONS.find(
    v => props.value && v.id.toString() === props.value.toString(),
  );

  return (
    <PrimarySelect
      {...props}
      renderWithoutPopover
      className={classNames(
        AUTOMATION_REPORTING_EVENT_SELECTOR_JS_CLASS.replace('.', ''),
        automationStyles.select,
        props?.className,
      )}
      customArrowIcon={
        <AngleDownLightIcon
          className={classNames(automationStyles.selectArrow)}
          color={props.disabled ? '#8C8C8C' : '#262626'}
        />
      }
      customOptionRenderer={opt => (
        <>
          {opt.icon}
          {opt.name}
        </>
      )}
      options={REPORTING_OPTIONS}
      value={value}
    />
  );
};

const formatter = {
  waiting(count: number = 0) {
    return `Waiting for engagement: ${numFormatter.int(count)}`;
  },
  clicked(count: number = 0, percent: number = 0) {
    return `Clicked: ${numFormatter.percent(percent)} – ${numFormatter.int(
      count,
    )}`;
  },
  opened(count: number = 0, percent: number = 0) {
    return `Opened: ${numFormatter.percent(percent)} – ${numFormatter.int(
      count,
    )}`;
  },
  queued(count: number = 0, timeToDeliverSec: number) {
    return `Queued: ${numFormatter.int(count)}${
      count
        ? `(${moment
            .duration(timeToDeliverSec, 'seconds')
            .humanize()} to complete)`
        : ''
    }`;
  },
  sent(count: number = 0) {
    return `Sent: ${numFormatter.int(count)}`;
  },
};

// tslint:disable-next-line:cyclomatic-complexity
export const AutomationEditEmailSold: FunctionComponent<Props> = props => {
  const { automationData } = props;
  const { state, actions } = automationData;
  const campaignId = state.source?.id;
  const triggers = useInputTriggersIdentification(campaignId);
  const [addingInputTrigger, setAddingInputTrigger] = useState(false);

  const chatbotId = useSelector(activeChatbotIdSelector);

  const storeCampaign = useSelector(state =>
    selectCampaignById(state, campaignId || -1),
  );

  const {
    // destinationPageId: dialogueId,
    // destinationPageGroupId: pageGroupId,
    scheduledAt,
    intervalInMin,
  } = state?.source?.[0] || {};

  const relatedCampaignId = storeCampaign?.relatedCampaigns?.[0]?.id;

  const storeRelatedCampaign = useSelector(state =>
    selectCampaignById(state, relatedCampaignId || -1),
  );

  const { destinationPageId: dialogueId, destinationPageGroupId: pageGroupId } =
    state.source?.schedulersAttributes?.[0] || {};

  const [fetchingRootDialogue, setFetchingRootDialogue] = useState(false);
  const [fetchingVerifiedStats, setFetchingVerifiedStats] = useState(false);

  const [widgets, setWidgets] = useState<WidgetModel[]>();
  const [dialogue, setDialogue] = useState<PageModel>();
  const [verifiedStats, setVerifiedStats] =
    useState<AutomationVerifiedStatsType>();

  const modalActions = useModalActions();

  const history = useHistory<{ firstTime?: boolean }>();
  const viewActions = useViewActions();
  const openEmailSlideout = () => {
    viewActions.showSlideoutMenu('automationEmailSmsSettings', {
      campaignId,
    });
  };

  const defaultEmailAccountsIds = storeCampaign?.emailAccountsIds || [];

  const accounts = useSelector(selectEmailAccounts);
  const activeFbPageId = useSelector(activeFacebookPageIdSelector);
  const emailAccountsCRUDActions = useEmailAccountCRUDActions();

  useEffect(() => {
    if (history.location.state?.firstTime) {
      openEmailSlideout();
      history.replace(history.location.pathname, {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!accounts.length) {
      emailAccountsCRUDActions.getAccounts(activeFbPageId);
    }
  }, []);

  const showInactiveEmailAlert = useMemo(() => {
    if (!defaultEmailAccountsIds?.length && !accounts?.length) {
      return {
        show: true,
        plural: true,
      };
    }

    const usedAccount = defaultEmailAccountsIds
      .map(emailId => accounts.find(a => a.id === emailId))
      .filter(Boolean);

    const accountsWithErrors = usedAccount.filter(account => {
      return (
        account?.kind === 'gmail' &&
        account?.credential &&
        !account?.credential?.fullGmailScope
      );
    });

    return {
      show: accountsWithErrors.length,
      plural: !!accountsWithErrors.length,
    };
  }, [defaultEmailAccountsIds.join(''), accounts]);

  const onClick = () => {};

  const renderSoldEmailSlideoutTitle = (
    <div className={automationStyles.soldSlideoutTitle}>
      <SoldIcon className={automationStyles.soldSlideoutTitleIcon} />
      <Heading size={4}>S.o.L.D. Email</Heading>
    </div>
  );

  const dialogues = useDialogues();

  const fetchRootDialogue = async () => {
    if (dialogueId) {
      setFetchingRootDialogue(true);
      try {
        const { widgets, dialogue } = await dialogues.fetch(dialogueId);
        setWidgets(widgets);
        setDialogue(dialogue);
      } catch (err) {
      } finally {
        setFetchingRootDialogue(false);
      }
    }
  };

  const fetchValidatorStats = async (cId?: number) => {
    if (cId) {
      setFetchingVerifiedStats(true);
      try {
        const stats = await AutomationController.getVerifiedStats(cId);
        if (stats?.verifiedStats) {
          setVerifiedStats(stats);
        }
      } catch (err) {
      } finally {
        setFetchingVerifiedStats(false);
      }
    }
  };

  const { activateBotGuard } = useInactiveBotActivator();

  useEffect(() => {
    fetchRootDialogue();
  }, [dialogueId]);

  useEffect(() => {
    fetchValidatorStats(campaignId);
  }, [campaignId]);

  const soldWidget = (widgets || dialogue?.widgets || []).find(
    w => w?.config?.kind === 'email_sold',
  );
  const soldWidgetConfig = soldWidget?.config as unknown as EmailConfig;
  const editorBaseWidget = widgets?.[1] || dialogue?.widgets?.[1];

  const soldWidgetReviewed = useSelector(
    (state: StoreState) =>
      state.widget.entities.find(w => w.id === soldWidget?.id)?.validated
        ?.facebook,
  );

  const openSoldEmailEditSlideout = e => {
    if (soldWidget) {
      return viewActions.showSlideoutMenu('email', {
        title: renderSoldEmailSlideoutTitle,
        showSmartSendingInfo: true,
        chatbotId,
        dialogueId,
      });
    }
  };

  const reduxState = useSelector<StoreState, IAutomationState>(
    state => state.automation,
  );

  const reduxActions = useAutomationActions();

  const [elements, setElements] = useState([]);

  const onChange = (_, elements) => {
    setElements(elements);
  };

  const hideOpenMenus = () => {
    if (reduxState.action || addingInputTrigger) {
      reduxActions.hideActionsList();
      setAddingInputTrigger(false);
    }
  };

  const showSoldStep = !!triggers?.length && !!soldWidget;
  const isReengagementUnlocked = showSoldStep && soldWidgetReviewed;

  const hasValidEmails = useSelector((store: StoreState) => {
    const pageIds = store.widget.entities
      .filter(widget => widget.pageId === dialogueId)
      .filter(w => w.type === WidgetTypes.NAVIGATE)
      .map(w => w.config.pageId);

    return store.widget.entities
      .filter(w => w.type === WidgetTypes.EMAIL)
      .filter(w => pageIds.includes(w.pageId))
      .some(w => w.validated.facebook);
  });

  const isReportingUnlocked = hasValidEmails && isReengagementUnlocked;

  useEffect(() => {
    if (isReportingUnlocked && state?.source?.needsReview && campaignId) {
      campaignCRUDActions.updateCampaign(
        {
          id: campaignId,
          needsReview: false,
        } as unknown as CampaignType,
        chatbotId,
      );
    }
  }, [isReportingUnlocked]);

  const featureFlags = useSelector(combinedFeatureFlagsSelector);
  const showEmailReportSettingsButton = true; // featureFlags['email_report'];

  const onStart = async () => {
    // Disable per "urgent" PM request
    // if (!isReportingUnlocked) {
    //   errorToast('Configure all steps before start', 'top-right');
    //   return;
    // }

    await activateBotGuard();
    await actions.start();
  };

  const renderRootNode = (
    <span
      className={classNames(
        automationStyles.rootNode,
        automationStyles.withLine,
      )}
    >
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          /* tslint:disable-next-line:max-line-length */
          d="M26.2 14.58a.96.96 0 0 0-.8-.44h-6.76V3.54a.96.96 0 0 0-1.84-.4L9.08 20.5a.96.96 0 0 0 .88 1.36h6.75v10.6a.96.96 0 0 0 1.85.4l7.71-17.36c.14-.3.11-.64-.07-.92Z"
          fill="#FAAD14"
        />
      </svg>
    </span>
  );

  const renderTotalStatsCount = fetchingVerifiedStats ? (
    <Spinner standalone size={8} />
  ) : (
    <>{numFormatter.int(verifiedStats?.verifiedStats?.totalEmailsCount)}</>
  );

  const renderVerifiedStatsCount = fetchingVerifiedStats ? (
    <Spinner standalone size={8} />
  ) : (
    <>{numFormatter.int(verifiedStats?.verifiedStats?.verifiedEmailsCount)}</>
  );

  const renderNotValidatedStatsCount = fetchingVerifiedStats ? (
    <Spinner standalone size={8} />
  ) : (
    <>
      {numFormatter.int(verifiedStats?.verifiedStats?.notVerifiedEmailsCount)}
    </>
  );

  const renderSuppressedStatsCount = fetchingVerifiedStats ? (
    <Spinner standalone size={8} />
  ) : (
    <>{numFormatter.int(verifiedStats?.verifiedStats?.suppressedCount)}</>
  );

  const renderAutomatedEmailValidatorNode = (
    <div
      className={classNames(
        common.card,
        automationStyles.node,
        automationStyles.withLine,
      )}
      onClick={onClick}
    >
      <PrimaryToolTip
        useHover
        classNameArrow={automationStyles.emailValidatorStatTooltipArrow}
        anchorElement={
          <div className={automationStyles.body}>
            <div className={automationStyles.info}>
              <div className={automationStyles.icon}>
                <SafetyOutlined className={automationStyles.cyan} />
              </div>
              <div className={automationStyles.headerContent}>
                <div className={automationStyles.headerText}>
                  <span className={automationStyles.placeholder}>
                    Automated Email Validator
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
        classNameContainer={automationStyles.emailValidatorStatTooltip}
        position="right"
        withoutLine
        zIndex={1000}
      >
        <div className={automationStyles.emailValidatorStats}>
          <div className={automationStyles.emailValidatorStat}>
            <span className={automationStyles.peopleIcon}>
              <PeopleIcon />
            </span>
            <span>Total:</span>
            <span>{renderTotalStatsCount}</span>
          </div>

          <div className={automationStyles.emailValidatorStat}>
            <span className={automationStyles.safetyIcon}>
              <SafetyOutlined className={automationStyles.green} />
            </span>
            <span>Validated:</span>
            <span>{renderVerifiedStatsCount}</span>
          </div>

          <div className={automationStyles.emailValidatorStat}>
            <span className={automationStyles.stopIcon}>
              <StopOutlined />
            </span>
            <span>Not validated:</span>
            <span>{renderNotValidatedStatsCount}</span>
          </div>

          <div className={automationStyles.emailValidatorStat}>
            <span className={automationStyles.stopIcon}>
              <MinusOutlined />
            </span>
            <span>Suppressed:</span>
            <span>{renderSuppressedStatsCount}</span>
          </div>
        </div>
      </PrimaryToolTip>
    </div>
  );

  const [expanded, setExpanded] = useState(false);

  const toggleStatsExpand = e => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const renderSchedulerNode = campaignId ? (
    <div className={classNames(automationStyles.withLine)}>
      <Scheduler
        className={automationStyles.scheduler}
        data={{ campaignId, intervalInMin, schedulerDateTimeVisible: true }}
        withHandle={false}
      />
    </div>
  ) : (
    <></>
  );

  const renderSOLDEmailNode = (
    <div className={automationStyles.soldNodeWrapper}>
      {!soldWidgetReviewed && <ReviewBadge />}
      <div
        className={classNames(common.card, automationStyles.node)}
        onClick={openSoldEmailEditSlideout}
      >
        <div className={automationStyles.body}>
          <div className={automationStyles.info}>
            <SoldIcon className={automationStyles.icon} />

            <div className={automationStyles.headerContent}>
              <div className={automationStyles.headerText}>
                <span className={automationStyles.placeholder}>
                  S.o.L.D. Email
                </span>

                <span className={automationStyles.value}>
                  Check if your leads are live and interacting
                </span>
              </div>
            </div>
          </div>

          <div
            className={classNames(automationStyles.nodeStatsContainer, {
              [automationStyles.expanded]: expanded,
            })}
          >
            {!expanded ? (
              <>
                <Count
                  className={automationStyles.count}
                  icon={<SendOutlined />}
                  value={numFormatter.int(soldWidgetConfig?.emailSendsCount)}
                />
                <Count
                  className={automationStyles.count}
                  icon={
                    <span className={automationStyles.nudgeTopIcon}>
                      <MailIcon />
                    </span>
                  }
                  value={numFormatter.percent(
                    soldWidgetConfig?.opensPercentage,
                  )}
                />
                <Count
                  className={automationStyles.count}
                  icon={
                    <span className={automationStyles.nudgeTopIcon}>
                      <ClickIcon />
                    </span>
                  }
                  value={numFormatter.percent(
                    soldWidgetConfig?.clicksPercentage,
                  )}
                />
                <span
                  className={automationStyles.expandBtn}
                  onClick={toggleStatsExpand}
                >
                  <AngleDownLightIcon color="#262626" />
                  Expand
                </span>
              </>
            ) : (
              <>
                <div className={automationStyles.nodeStats}>
                  <Count
                    className={automationStyles.count}
                    icon={
                      <span className={automationStyles.usersIcon}>
                        <PeopleIcon />
                      </span>
                    }
                    value={
                      <span className={automationStyles.countTextRow}>
                        Total: {renderVerifiedStatsCount}
                      </span>
                    }
                  />
                  <Count
                    className={automationStyles.count}
                    icon={<SendOutlined />}
                    value={formatter.sent(soldWidgetConfig?.emailSendsCount)}
                  />
                  <Count
                    className={automationStyles.count}
                    icon={<SyncOutlined />}
                    value={
                      <span className={automationStyles.countTextRow}>
                        {formatter.queued(
                          soldWidgetConfig?.emailQueuedCount,
                          Array.isArray(soldWidgetConfig?.timeToDeliverAll)
                            ? soldWidgetConfig?.timeToDeliverAll[1]
                            : 0,
                        )}
                        <PrimaryToolTip
                          useHover
                          classNameArrow={
                            automationStyles.connectMoreTooltipArrow
                          }
                          anchorElement={
                            <QuestionCircleOutlined
                              className={automationStyles.geekblue}
                            />
                          }
                          classNameContainer={
                            automationStyles.connectMoreTooltip
                          }
                          position="bottom"
                          withoutLine
                        >
                          <div
                            className={
                              automationStyles.connectMoreTooltipContent
                            }
                          >
                            Connect more email accounts to increase sending
                            speed
                            <Button
                              onClick={e => {
                                e?.stopPropagation();
                                modalActions.openActivateEmailAccountModal();
                              }}
                            >
                              Connect emails
                            </Button>
                          </div>
                        </PrimaryToolTip>
                      </span>
                    }
                  />
                  <Count
                    className={automationStyles.count}
                    icon={
                      <span className={automationStyles.countIcon}>
                        <MailIcon />
                      </span>
                    }
                    value={formatter.opened(
                      soldWidgetConfig?.emailOpensCount,
                      soldWidgetConfig?.opensPercentage,
                    )}
                  />
                  <Count
                    className={automationStyles.count}
                    icon={
                      <span className={automationStyles.nudgeTopIcon}>
                        <ClickIcon />
                      </span>
                    }
                    value={formatter.clicked(
                      soldWidgetConfig?.emailClicksCount,
                      soldWidgetConfig?.clicksPercentage,
                    )}
                  />

                  <Count
                    className={automationStyles.count}
                    icon={
                      <span>
                        <ClockCircleOutlined />
                      </span>
                    }
                    value={formatter.waiting(
                      soldWidgetConfig?.waitingEngagementCount,
                    )}
                  />
                </div>
                <span
                  className={automationStyles.collapseBtn}
                  onClick={toggleStatsExpand}
                >
                  <AngleUpLightIcon color="#262626" />
                  Collapse
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const campaignCRUDActions = useCampaignCRUDActions();

  const activateSoldNotifications = async () => {
    const soldConfigurations = JSON.parse(
      JSON.stringify(
        storeCampaign?.soldConfigurations
          ? storeCampaign?.soldConfigurations
          : soldConfigInitialValues,
      ),
    );
    soldConfigurations.unicorn.notifications.rule.open = 1;
    soldConfigurations.unicorn.notifications.defaultConfiguration = false;

    try {
      const res = await campaignCRUDActions.updateCampaign(
        {
          id: campaignId,
          soldConfigurations,
        } as unknown as CampaignType,
        chatbotId,
      );

      successToast('Your changes have been saved.', 'top-left');
    } catch (ee) {
      errorToast('Something went wrong', 'top-left');
    }
  };

  const activateHotLeadNotifications = async () => {
    const soldConfigurations = JSON.parse(
      JSON.stringify(
        storeCampaign?.soldConfigurations
          ? storeCampaign?.soldConfigurations
          : soldConfigInitialValues,
      ),
    );
    soldConfigurations.unicorn.notifications.rule.open = 1;
    soldConfigurations.unicorn.notifications.defaultConfiguration = false;

    try {
      const res = await campaignCRUDActions.updateCampaign(
        {
          id: campaignId,
          soldConfigurations,
        } as unknown as CampaignType,
        chatbotId,
      );

      successToast('Your changes have been saved.', 'top-left');
    } catch (ee) {
      errorToast('Something went wrong', 'top-left');
    }
  };

  const handleSalesTeamNodeClick = async (event: any) => {
    const { target } = event as MouseEvent;
    if (
      target instanceof Node &&
      hasParentWithSelector(
        event.target as any,
        AUTOMATION_REPORTING_EVENT_SELECTOR_JS_CLASS,
      )
    ) {
      return;
    }

    if (
      storeCampaign?.soldConfigurations?.unicorn?.notifications
        ?.defaultConfiguration
    ) {
      await activateSoldNotifications();
    }

    return viewActions.showSlideoutMenu('automationSalesTeamNotifications', {
      chatbotId,
      campaignId,
    });
  };

  const reportEvent = getCampaignActiveReportingOptionId(storeCampaign);

  const handleSalesTeamNodeSelectorChange = async (opt: DropdownOption) => {
    if (storeCampaign?.soldConfigurations) {
      const event = opt.id;
      const clone = JSON.parse(
        JSON.stringify(storeCampaign.soldConfigurations),
      );

      if (event in clone.unicorn.notifications.rule) {
        clone.unicorn.notifications.rule.open = 0;
        clone.unicorn.notifications.rule.reply = 0;
        clone.unicorn.notifications.rule.click = 0;
        clone.unicorn.notifications.rule[event] = 1;
      }

      try {
        const res = await campaignCRUDActions.updateCampaign(
          {
            id: campaignId,
            soldConfigurations: clone,
          } as unknown as CampaignType,
          chatbotId,
        );

        successToast('Your changes have been saved.', 'top-left');
      } catch (ee) {
        errorToast('Something went wrong', 'top-left');
      }
    }
  };

  const visibleActionsFilterFunc =
    reduxState.action?.campaignId === storeRelatedCampaign?.id
      ? action =>
          ![
            EAutomationAction.UNICORN_DETECTOR,
            EAutomationAction.CONDITION,
          ].includes(action)
      : undefined;

  const salesTeamNodeInactive =
    !getIsCampaignReportingStatusActive(storeCampaign);

  const renderSalesTeamNode = (
    <div
      className={classNames(common.card, automationStyles.reportingNode, {
        [automationStyles.inactive]:
          salesTeamNodeInactive || !isReportingUnlocked,
      })}
      onClick={handleSalesTeamNodeClick}
    >
      {!isReportingUnlocked && (
        <span className={automationStyles.disabledTooltip}>
          Please complete the previous step in your automation to unlock this
        </span>
      )}

      {(!storeCampaign?.soldConfigurations ||
        storeCampaign?.soldConfigurations?.unicorn?.notifications
          ?.defaultConfiguration) && (
        <ReviewBadge
          className={automationStyles.badge}
          text="Click to activate"
        />
      )}

      <HandIcon
        className={automationStyles.icon}
        color={salesTeamNodeInactive ? '#8C8C8C' : '#40A9FF'}
      />
      <span className={automationStyles.placeholder}>
        Introduce to Sales Team
      </span>

      <span className={automationStyles.value}>
        Connect to your team if the lead:
      </span>

      <span className={automationStyles.selector}>
        <AutomationReportingEventSelector
          disabled={salesTeamNodeInactive}
          value={reportEvent}
          onChange={handleSalesTeamNodeSelectorChange}
        />
      </span>
    </div>
  );

  const createRelatedCampaign = async () => {
    if (campaignId) {
      try {
        const res = await campaignCRUDActions.createRelatedCampaign(
          campaignId,
          'unicorn_detector',
        );

        const relatedCampaign = res?.campaign?.[0];

        if (res?.success && relatedCampaign) {
          // activate parent campaign sold
          const clone = JSON.parse(
            JSON.stringify(storeCampaign?.soldConfigurations),
          );

          clone.unicorn.open = 1;

          await campaignCRUDActions.updateCampaign(
            {
              id: storeCampaign?.id,
              soldConfigurations: clone,
            } as CampaignType,
            chatbotId,
          );

          successToast('Activated', 'top-left');
        }
      } catch (ee) {
        errorToast('Something went wrong', 'top-left');
      }
    }
  };

  const handleHotLeadAutomationClick = async (event: any) => {
    const { target } = event as MouseEvent;
    if (
      target instanceof Node &&
      hasParentWithSelector(
        event.target as any,
        AUTOMATION_REPORTING_EVENT_SELECTOR_JS_CLASS,
      )
    ) {
      return;
    }

    if (!storeCampaign?.relatedCampaigns?.length) {
      await createRelatedCampaign();
    }

    return viewActions.showSlideoutMenu('automationHotLeadAutomation', {
      chatbotId,
      campaignId,
    });
  };

  const hotLeadAutomationNodeInactive =
    !getIsRelatedCampaignReportingStatusActive(storeCampaign);

  const hotLeadEvent = getCampaignSoldReportingOptionId(storeCampaign);

  const handleHotLeadSelectorChange = async (opt: DropdownOption) => {
    if (storeCampaign?.soldConfigurations) {
      const event = opt.id;
      const clone = JSON.parse(
        JSON.stringify(storeCampaign.soldConfigurations),
      );

      if (event in clone.unicorn) {
        clone.unicorn.open = 0;
        clone.unicorn.reply = 0;
        clone.unicorn.click = 0;
        clone.unicorn[event] = 1;
      }

      try {
        const res = await campaignCRUDActions.updateCampaign(
          {
            id: campaignId,
            soldConfigurations: clone,
          } as unknown as CampaignType,
          chatbotId,
        );

        successToast('Your changes have been saved.', 'top-left');
      } catch (ee) {
        errorToast('Something went wrong', 'top-left');
      }
    }
  };

  const renderHotLeadAutomationNodeCard = (
    <div
      className={classNames(common.card, automationStyles.reportingNode, {
        [automationStyles.inactive]:
          hotLeadAutomationNodeInactive || !isReportingUnlocked,
      })}
      onClick={handleHotLeadAutomationClick}
    >
      {!isReportingUnlocked && (
        <span className={automationStyles.disabledTooltip}>
          Please complete the previous step in your automation to unlock this
        </span>
      )}

      {!storeCampaign?.relatedCampaigns?.length && (
        <ReviewBadge
          className={automationStyles.badge}
          text="Click to activate"
        />
      )}

      <HotLeadIcon
        className={automationStyles.icon}
        color={hotLeadAutomationNodeInactive ? '#8C8C8C' : '#389E0D'}
      />
      <span className={automationStyles.placeholder}>
        New Hot Lead Automation
      </span>

      <span className={automationStyles.value}>
        Continue the conversation if the lead:
      </span>

      <span className={automationStyles.selector}>
        <AutomationReportingEventSelector
          disabled={hotLeadAutomationNodeInactive}
          value={hotLeadEvent}
          onChange={handleHotLeadSelectorChange}
        />
      </span>
    </div>
  );

  const renderHotLeadAutomationNode = (
    <div className={automationStyles.reportingNodeContainer}>
      {renderHotLeadAutomationNodeCard}
      {relatedCampaignId && (
        <CampaignDialogueEditor
          className={classNames(automationStyles.reportingNodeEditor, {
            [automationStyles.reportingNodeEditorDisabled]:
              !isReportingUnlocked,
          })}
          campaignId={relatedCampaignId}
        />
      )}
    </div>
  );

  const actionListCampaignId = reduxState.action?.campaignId || campaignId;

  if (!campaignId) {
    return <Spinner standalone size={32} />;
  }

  return (
    <div
      className={automationStyles.container}
      style={{
        backgroundImage: `url(${bgIcon})`,
        backgroundSize: '100% 24px',
      }}
    >
      <AutomationHeader state={state} actions={actions} onStart={onStart} />

      <InactiveBotAlert />

      {!!showInactiveEmailAlert?.show && (
        <InactiveEmailAlert plural={showInactiveEmailAlert?.plural} />
      )}

      <div className={automationStyles.editor}>
        <Step
          number={1}
          className={automationStyles.step}
          lineStyle="dotted"
          circleStyle="shadow"
          numberStyle="bold"
        >
          <div className={automationStyles.stepTitle}>
            Do you want to create an email or SMS automation?
          </div>
          <div className={automationStyles.stepSubtitle}>
            Choose which accounts you will contact your leads with
          </div>
          <div className={automationStyles.channels}>
            <AutomationChannelButton
              channel="email"
              onClick={openEmailSlideout}
              enableSwitchChannelButton
            />
          </div>
        </Step>
        <Step
          number={2}
          className={automationStyles.triggerStep}
          lineStyle={showSoldStep ? 'dotted' : 'none'}
          circleStyle="shadow"
          numberStyle="bold"
        >
          <div className={automationStyles.stepTitle}>
            Choose one or more Input Triggers
          </div>
          {triggers === null && state.busy === 'fetching' && (
            <Spinner size={24} standalone />
          )}

          {!!triggers && (
            <InputTriggers
              campaignId={campaignId}
              triggers={triggers}
              onAddInputTriggerClicked={() => setAddingInputTrigger(true)}
            />
          )}
        </Step>

        <Step
          number={3}
          className={automationStyles.step}
          lineStyle="dotted"
          circleStyle="shadow"
          numberStyle="bold"
          disabled={!showSoldStep}
          disabledTooltip="Please complete the previous step in your automation to unlock this"
        >
          <div className={automationStyles.stepTitle}>
            Check leads for Signs of Life (S.o.L.D.)
          </div>
          <div className={automationStyles.stepSubtitle}>
            Check your leads list to see if they are active. Users that engage
            with this will proceed to the next step of your automation.
          </div>

          <div className={automationStyles.diagramWrapper}>
            {renderRootNode}
            {renderAutomatedEmailValidatorNode}
            {renderSchedulerNode}
            {renderSOLDEmailNode}
          </div>
        </Step>

        {dialogueId && campaignId && (
          <Step
            number={4}
            title="Your Outreach Automation"
            lineStyle="dotted"
            circleStyle="shadow"
            numberStyle="bold"
            disabled={!isReengagementUnlocked}
            disabledTooltip="Please complete the previous step in your automation to unlock this"
          >
            <div className={automationStyles.stepSubtitle}>
              Automatically find your most valuable leads with the highest
              likelihood of converting.
            </div>
            <DialogueEditor
              className={automationStyles.flowchart}
              dialogueId={dialogueId}
              campaignId={campaignId}
              pageGroupId={pageGroupId}
              schedulerDateTimeVisible={false}
              scheduledAt=""
              intervalInMin={0}
              onPaneClick={hideOpenMenus}
              onMoveStart={hideOpenMenus}
              onChange={onChange}
              withBackground={false}
            />
          </Step>
        )}

        <Step
          number={5}
          className={automationStyles.step}
          lineStyle="none"
          circleStyle="shadow"
          numberStyle="bold"
        >
          <div className={automationStyles.stepTitle}>
            What do you want to do with your Hot Leads?
          </div>
          <div className={automationStyles.stepSubtitle}>
            Choose your automations for leads that have shown the highest intent
            of converting.
          </div>

          {showEmailReportSettingsButton && (
            <Button
              css={{ container: automationStyles.reportingBtn }}
              leftIcon={<SettingFilled />}
              onClick={() =>
                viewActions.showSlideoutMenu('automationReporting', {
                  campaignId,
                })
              }
            >
              Reporting Settings
            </Button>
          )}

          <div
            className={classNames(automationStyles.reportingContainer, {
              [automationStyles.disabled]: !isReportingUnlocked,
            })}
            onClickCapture={e => {
              if (!isReportingUnlocked) {
                e.stopPropagation();
              }
            }}
          >
            {renderSalesTeamNode}
            {renderHotLeadAutomationNode}
          </div>
        </Step>

        {campaignId && addingInputTrigger && (
          <div className={styles.modal}>
            <NewInputTriggerChooser
              triggers={triggers}
              className={styles.triggerChooser}
              campaignId={campaignId}
              setAddingInputTrigger={setAddingInputTrigger}
              onClose={() => setAddingInputTrigger(false)}
            />
          </div>
        )}

        <TransitionWrapper>
          {actionListCampaignId && reduxState.action && (
            <ActionsList
              {...reduxState.action}
              className={styles.actionsList}
              campaignId={actionListCampaignId}
              visibleActionsFilterFunc={visibleActionsFilterFunc}
            />
          )}
        </TransitionWrapper>
      </div>
    </div>
  );
};
